import { Box, Typography, Button, Container, useTheme } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

function ContactSection() {
  const theme = useTheme();
  
  // Replace with your actual Calendly link
  const calendlyLink = 'https://calendly.com/supreet88/discovery-call';
  
  return (
    <Box 
      id="book"
      sx={{ 
        py: { xs: 8, md: 12 },
        bgcolor: 'background.paper',
        position: 'relative',
        overflow: 'hidden',
        textAlign: 'center'
      }}
    >
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 2 }}>
        <Box textAlign="center" mb={6}>
          <Typography 
            variant="h2" 
            component="h2"
            sx={{ 
              color: 'primary.main',
              mb: 3,
              fontWeight: 700
            }}
          >
            Book a Discovery Call
          </Typography>
          <Typography 
            variant="h5" 
            component="p"
            sx={{ 
              color: 'text.secondary',
              maxWidth: '700px',
              mx: 'auto',
              mb: 4,
              lineHeight: 1.6
            }}
          >
            Ready to take the first step towards your transformation? Let's have a conversation to explore how I can support your journey.
          </Typography>
        </Box>

        <Box 
          sx={{ 
            bgcolor: 'background.paper',
            p: { xs: 4, md: 6 },
            borderRadius: 2,
            boxShadow: 3,
            maxWidth: '700px',
            mx: 'auto',
            textAlign: 'center'
          }}
        >
          <Box 
            sx={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              bgcolor: 'primary.light',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 4
            }}
          >
            <CalendarMonthIcon 
              sx={{ 
                color: 'primary.main',
                fontSize: '50px'
              }} 
            />
          </Box>
          
          <Typography 
            variant="h5" 
            component="h3"
            sx={{ 
              color: 'text.primary',
              mb: 3,
              fontWeight: 600
            }}
          >
            Schedule Your Free Discovery Call
          </Typography>
          
          <Typography 
            variant="body1" 
            sx={{ 
              color: 'text.secondary',
              mb: 4,
              maxWidth: '600px',
              mx: 'auto',
              lineHeight: 1.7
            }}
          >
            During this 30-minute call, we'll discuss your goals, challenges, and how coaching can help you achieve the transformation you're looking for. No pressure, just a friendly conversation to see if we're a good fit.
          </Typography>
          
          <Button
            variant="contained"
            color="primary"
            size="large"
            href={calendlyLink}
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<CalendarMonthIcon />}
            sx={{
              py: 1.5,
              px: 4,
              fontSize: '1.1rem',
              fontWeight: 600,
              borderRadius: '50px',
              textTransform: 'none',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: `0 6px 16px -4px ${theme.palette.primary.main}80`,
                backgroundColor: 'primary.dark',
              },
              transition: 'all 0.3s ease-in-out',
            }}
          >
            Book Your Free Call Now
          </Button>
          
          <Typography 
            variant="body2" 
            sx={{ 
              mt: 3,
              color: 'text.secondary',
              fontStyle: 'italic'
            }}
          >
            No credit card required. Cancel or reschedule anytime.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default ContactSection;